
import { defineComponent } from "vue";
import { Field, Form } from "vee-validate";
import locationStore from "@/store/location";
import weatherStore from "@/store/weather";
import { mande } from "mande";
import { useToast } from "vue-toastification"
export default defineComponent({
  name: "SearchComponent",
  setup() {
    const locationInfo = locationStore();
    const weatherInfo = weatherStore();
    const toast = useToast();
    return {
      locationInfo,
      weatherInfo,
      toast
    };
  },

  components: {
    Field,
    Form,
  },
  methods: {
    async fetchWeather(e) {
      console.log(e.location);
      this.locationInfo.setCoordinates(e.location);
      this.getWeather();
    },
    async getWeather() {
      try {
        interface keyShape {
          data: Array<any>;
        }
        const key: keyShape = await mande(
          `https://api.weatherbit.io/v2.0/forecast/daily?city=${this.locationInfo.city}&days=7&&key=${this.locationInfo.accuWeather}`
        ).get("");

        this.weatherInfo.setForecast(key.data);
      } catch (error) {
        this.toast.error("Unable to fetch weather information")
      }
    },
  },
});
